import Image from "next/image";
import Link from "next/link";
import { cx } from "@/utils/util";
import { IBlogPosts } from "@/pages/blog/IBlog";
interface IPostListProps {
  post: IBlogPosts["data"][0];
  aspect?: "landscape";
}

export default function PostList({ post, aspect }: IPostListProps) {
  return (
      <div className="overflow-hidden bg-white rounded hover:shadow-xl">
        <div className="px-3 py-3 flex flex-column justify-between h-full">
          <div className="relative">
            <Link href={`/blog/post/${post.attributes.slug}`}  title={post.attributes.Title} className="block aspect-w-4 aspect-h-3">
              <Image
                src={
                  post.attributes.Image.data?.attributes?.url
                }
                alt={String(post.attributes.Image.data.attributes.alternativeText)}
                height={600}
                width={600}
                className="transition-all object-cover w-full h-full rounded-xl"
                priority
              />
            </Link>
          </div>
          <div>
          <span className="block mt-3 text-sm font-semibold tracking-widest text-gray-800">
            {" "}
            <time
              className="text-sm"
              dateTime={
                post.attributes.publishedAt || post.attributes.createdAt
              }
            >
              {new Date(
                post.attributes.publishedAt || post.attributes.createdAt
              ).toDateString()}
            </time>{" "}
          </span>
          <h2 className="my-2 text-xl font-semibold">
            <Link
              href={`/blog/post/${post.attributes.slug}`}
              title={post.attributes.Title}
              className="text-black"
            >
              {post.attributes.Title}
            </Link>
          </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="relative flex-shrink-0 h-10 w-10 ">
              <Image
                src={
                
                    post.attributes.authorPic.data?.attributes?.url ||
                  `https://api.dicebear.com/6.x/fun-emoji/svg?seed=${post.attributes.author}`
                }
                alt={"Author Name"}
                className="rounded-full h-full "
                height={40}
                width={40}
              />
            </div>
            <span className="text-sm font-medium"> {post.attributes.author} </span>
          </div>
        </div>
      </div>
  );
}

